module.exports = __webpack_public_path__ + "cc8d8f1716b234b935bd43c7e994e9ea.svg";